module.exports = __webpack_public_path__ + "static/img/putio.7cf44df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/putio.svg
// module id = WeYu
// module chunks = 1